import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import MCQQuestion from "../../QuestionPage/Mcq";

// Fetching Data from the API]

// End

// Page Html
export default function HighlightCorrectSummaryMockPage({ question ,onInputChange ,questionNumber,maxQuestion}) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [Options, setOptions] = useState([]);
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isAttempted, setIsAttempted] = useState(false);
  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioLink(question.media_link);
    setOriginalWords(question.question);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
    resetAudio();
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleRetake = () => {
    setSelectedOption(null);
    setSubmitted(false);
    setIsAttempted(false);
  };

  const handleOptionSelect = (selectedOption) => {
    setSelectedOption(selectedOption);
    onInputChange(selectedOption);

  };

  useEffect(() => {
    console.log("Selected Options ", selectedOption);
  }, [selectedOption]);
  return (
    <div>
      <div className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
        <div className="h-1.5 rounded-full bg-violet-600"></div>
        <h3 className="pt-4 text-2xl font-extrabold text-gray-900 sm:text-3xl">
          Highlight Correct Summary
        </h3>
        <h2 className="hidden">
          {" "}
        </h2>
        <h2 className="mt-3 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="mt-4 max-w-5xl text-sm leading-6 text-gray-600 sm:text-base">
          Listen to the recording and choose the summary that best matches what you heard.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <MCQQuestion
          question={Mcq_Question}
          options={McqOptions}
          onOptionSelect={handleOptionSelect}
          selectedOption={selectedOption}
          submitted={submitted}
        />
      </div>
    </div>
  );
}


